import {
  CLIENT_LOADING,
  GET_CLIENT,
  GET_CLIENTS,
  CLIENT_LOADING_END,
} from "../actions/types";
import { getResponsePayload } from "../utils/reducerUtils";

const initialState = {
  loading: false,
  clients: [],
  client: {},
  pagination: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CLIENT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CLIENT_LOADING_END:
      return {
        ...state,
        loading: false,
      };

    case GET_CLIENT:
      return {
        ...state,
        loading: false,
        client: action.payload,
      };

    case GET_CLIENTS:
      const data = getResponsePayload(action);
      return {
        ...state,
        loading: false,
        clients: data.elements,
        pagination: data.pagination,
      };

    default:
      return state;
  }
}
